// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import HeadingWrapperComponent from "@store/Library/Components/HeadingWrapper";
import React, { FC } from "react";

const HeadingWrapper: FC<WidgetProps> = ({ id }) => (
    <HeadingWrapperComponent>
        <Zone contentId={id} zoneName="HeadingWrapper" />
    </HeadingWrapperComponent>
);

const widgetModule: WidgetModule = {
    component: HeadingWrapper,
    definition: {
        group: "Common",
        icon: "PageTitle",
    },
};

export default widgetModule;
